module.exports = __webpack_public_path__ + "img/img-message.64564037.png";